/**
 * Main Application
 * 
 * @type {Object}
 */
var SITE = {

    /**
     * Global settings.
     */
    Settings: {
        property: 'singlegrain'
    },

    /**
     * Preset Config Data
     * -----------------
     * Allows certain widgets to be changed
     * via on-page code snippets
     * 
     * @type {Object}
     */
    PreConfig: {},
    
    init: function() {
        "use strict"; 

        if (typeof SG_PRE_CONFIG !== "undefined") SITE.PreConfig = SG_PRE_CONFIG;

        SITE.UI.init();

        SITE.Pages.home.init();

        SITE.Drip && SITE.Drip.init();

        SITE.Modals.TabbedForm.init();

        SITE.Modals.SignupForm.init();
        SITE.Modals.ContactFormAlt.init();
        //SITE.Modals.Videoplayer.init();
        SITE.Modals.Topbar.init();
        
        SITE.Pages.init();
        SITE.Sharebar.init();

        SITE.Tracking && SITE.Tracking.init();
        SITE.Marketing && SITE.Marketing.init();

        SITE.Pages.common.search();

        // Hull integration
        $('form').submit(function() {

            var formId = $(this).attr('id');
            var dataTracking = $(this).attr('data-tracking');

            if(formId) {
                var formTitle = formId;
            } else {
                var formTitle = dataTracking;
            }

            var paramObj = {};
            $.each($(this).serializeArray(), function(_, kv) {
              if (paramObj.hasOwnProperty(kv.name)) {
                paramObj[kv.name] = $.makeArray(paramObj[kv.name]);
                paramObj[kv.name].push(kv.value);
              }
              else {
                paramObj[kv.name] = kv.value;
              }
            });

            if(paramObj['fields[email]']) {

                if(paramObj['fields[name]']) {
                    Hull.traits({
                        name: paramObj['fields[name]']
                    });
                }

                Hull.traits({
                    email: paramObj['fields[email]'],
                    "attribution/source": 'form_submission',
                    "attribution/inbound": true
                });
                Hull.track(formTitle + ' Form Submission', paramObj);

                console.log('Data was sent to Hull.');

            }
 
        });
        
    },

    /**
     * Update jQuery Validation defaults.
     */
    validationDefaults: function() {
        "use strict";

        // Update jQuery Validation defaults
        $.validator.setDefaults({
            highlight: function(element) {
                $(element).closest('.form-group').addClass('has-danger');
            },
            unhighlight: function(element) {
                $(element).closest('.form-group').removeClass('has-danger');
            }
        });

        // Create rule for simple website URL
        $.validator.addMethod(
            'website', 
            function( value, element ) {
                "use strict";

                var urlTestRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

                if( urlTestRegex.test( value ) == true ) {
                    return true;
                }

                var websiteTestRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/i;

                if( websiteTestRegex.test( value ) == true ) {
                    return true;
                }

                return false;
            },
            'Please enter a valid website URL.'
        );

        // Create a rule to block personal emails
        var bannedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com'];

        $.validator.addMethod(
            'workemail',
            function( value, element ) {
                "use strict";

                var domain = value.split('@')[1];

                return bannedDomains.indexOf(domain) < 0;
            },
            'Please enter your work email address.'
        );

    }
    
};

jQuery(document).ready(function() { 
    "use strict";

    SITE.init();
});